// removed by extract-text-webpack-plugin
module.exports = {"promo":"Promo-module__promo___9Ahk_"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Footer/Promo.module.scss
// module id = 204
// module chunks = 0 1